exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-red[data-v-353ece3f]{color:red}", ""]);

// exports
